import { classes } from '@skoda/k2tools-app-services/lib';
import * as React from 'react';
import styles from './styles.scss';

type SpinnerProps = {
	className?: string;
};

const Spinner: React.FC<SpinnerProps> = (props) => {
	return (
		<svg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg' className={classes(styles['svg-spinner'], props.className)}>
			<circle fill='transparent' strokeWidth='5px' stroke='#C2C7CB' cx='50' cy='50' r='24' />
			<circle
				className={styles['loader-ring']}
				fill='transparent'
				strokeWidth='5px'
				stroke='#419468'
				strokeDashoffset='276.460'
				strokeDasharray='276.460 276.460'
				cx='50'
				cy='50'
				r='24'
			/>
			<circle
				className={styles['loader-ring-overlay']}
				fill='transparent'
				strokeWidth='5px'
				stroke='#3E9922'
				strokeDashoffset='276.460'
				strokeDasharray='276.460 276.460'
				cx='50'
				cy='50'
				r='24'
			/>
		</svg>
	);
};

export default Spinner;
